import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, Validators, FormGroup} from '@angular/forms';
import {HttpHeaders} from "@angular/common/http";
import {Router} from '@angular/router';

import {Store} from '@ngrx/store';
import {filter, take} from 'rxjs/operators';
import {AuthService, ConfigService, StorageService} from "@cosbeni/auth";
import {FormHelperService} from "../services/form-helper.service";
import {ActivePromotionConfig} from "../config/active-promotion.config";
import {ToasterService} from "angular2-toaster";
import {TranslocoService} from "@jsverse/transloco";
import * as wjcCore from "@mescius/wijmo";
import {LoadUserAction} from "../ngrx/actions/user.action";
import {defaultRouteForRoles} from "../services/roles";


@Component({
    standalone: false,
    selector: 'app-dashboard',
    styleUrls: ['login.component.css'],
    templateUrl: 'login.component.html',
    encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
    account: any = {username: "", password: "", url: ActivePromotionConfig.DATABASE_URL, database: {name: ActivePromotionConfig.DATABASE}};
    form: FormGroup;

    constructor(public store: Store<any>,
                public router: Router,
                public formHelper: FormHelperService,
                public formBuilder: FormBuilder,
                public auth: AuthService,
                public config: ConfigService,
                public storage: StorageService,
                public toasterService: ToasterService,
                private transloco: TranslocoService) {
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            username: new FormControl('', [Validators.required, Validators.minLength(3)]),
            password: new FormControl('', [Validators.required, Validators.minLength(3)]),
        })
    }

    login(value: any) {
        // 旧 jQuery.param 相当 (application/x-www-form-urlencoded)。jQuery は同梱しない
        const data = new URLSearchParams({grant_type: 'password', username: value.username, password: value.password}).toString();
        this.storage.set(this.account.database.name + "_url", this.account.url, "");
        this.storage.set("database", this.account.database.name, "");
        this.config.setTokenPrefix(this.account.database.name);
        this.auth.login(data, this.account.url + '/token/' + this.account.database.name, {headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')})
            .subscribe(response => {
                    // ログイン後の着地先はロール(ケーパビリティ)で振り分ける。
                    // 固定で user/auction にすると、storefront 権限の無い管理者
                    // (例: 神戸オークション管理者)が管理画面に辿り着けない。
                    this.store.dispatch(new LoadUserAction());
                    this.store.select<any>("activePromotionFeature").pipe(
                        filter((f: any) => wjcCore.isObject(f.user) && f.user.loaded),
                        take(1),
                    ).subscribe((f: any) => {
                        const roles = f.user.user ? f.user.user.roles : null;
                        const route = defaultRouteForRoles(roles);
                        this.router.navigate([route === 'login' ? 'user/auction' : route]);
                    });
                },
                err => {
                    this.toasterService.pop("error", this.transloco.translate('shell.login_failed'), this.transloco.translate('shell.login_failed_detail'))
                },
            );
    }

}
